import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import path from 'enums/path';
import Home from 'pages/Home';
import RequestInvoice from 'pages/RequestInvoice';

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route exact component={RequestInvoice} path={path.RequestInvoice} />
      <Route component={Home} path={path.Home} />
    </Switch>
  </BrowserRouter>
);

export default Router;
